/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ButtonType {
  Register = 'register',
  Link = 'link',
  MoreInfo = 'moreInfo'
}
